/**
* @name: apiList.js
* @description: 接口地址列表，引用时，请解构使用，且不要定义别名
                命名规则：接口地址大写，并以下划线连接
* @author: 于海威
* @create: 2020/08/11 09:54:29
* @update: 2020/08/11 09:54:29
*/

// 认证
// 登录
export const NESTLE_SYSTEM_BACK_SERVER_LOGIN = '/nestle-system-back-server/login';
// 退出登录
export const NESTLE_SYSTEM_BACK_SERVER_LOGINOUT = '/nestle-system-back-server/logout';
// 菜单管理

// 系统管理
// 权限管理
// 权限管理 -- 权限列表
export const NESTLE_SYSTEM_BACK_SERVER_SYSTEM_PERMISSION_LIST = '/nestle-system-back-server/system/permission/list';
// 权限管理 -- 权限树形列表
export const NESTLE_SYSTEM_BACK_SERVER_SYSTEM_PERMISSION_LIST_MENU_TREE = '/nestle-system-back-server/system/permission/list/menu/tree';
// 权限管理 -- 删除权限
export const NESTLE_SYSTEM_BACK_SERVER_SYSTEM_PERMISSION_DELETE = '/nestle-system-back-server/system/permission/delete';
// 权限管理 -- 权限详情
export const NESTLE_SYSTEM_BACK_SERVER_SYSTEM_PERMISSION_DETAIL = '/nestle-system-back-server/system/permission/detail';
// 权限管理 -- 保存权限
export const NESTLE_SYSTEM_BACK_SERVER_SYSTEM_PERMISSION_SAVE = '/nestle-system-back-server/system/permission/save';
// 权限管理 -- 修改权限
export const NESTLE_SYSTEM_BACK_SERVER_SYSTEM_PERMISSION_UPDATE = '/nestle-system-back-server/system/permission/update';

// 角色管理
// 角色管理 -- 删除角色
export const NESTLE_SYSTEM_BACK_SERVER_SYSTEM_ROLE_DELETE = '/nestle-system-back-server/system/role/delete';
// 角色管理 -- 角色详情
export const NESTLE_SYSTEM_BACK_SERVER_SYSTEM_ROLE_DETAIL = '/nestle-system-back-server/system/role/detail';
// 角色管理 -- 停用角色
export const NESTLE_SYSTEM_BACK_SERVER_SYSTEM_ROLE_DISABLED = '/nestle-system-back-server/system/role/disabled';
// 角色管理 -- 启用角色
export const NESTLE_SYSTEM_BACK_SERVER_SYSTEM_ROLE_ENABLED = '/nestle-system-back-server/system/role/enabled';
// 角色管理 -- 分页角色
export const NESTLE_SYSTEM_BACK_SERVER_SYSTEM_ROLE_PAGE = '/nestle-system-back-server/system/role/page';
// 角色管理 -- 角色列表(不分页)
export const NESTLE_SYSTEM_BACK_SERVER_SYSTEM_ROLE_LIST = '/nestle-system-back-server/system/role/list';
// 角色管理 -- 保存角色
export const NESTLE_SYSTEM_BACK_SERVER_SYSTEM_ROLE_SAVE = '/nestle-system-back-server/system/role/save';
// 角色管理 -- 修改角色
export const NESTLE_SYSTEM_BACK_SERVER_SYSTEM_ROLE_UPDATE = '/nestle-system-back-server/system/role/update';

// 用户管理
// 用户管理 -- 用户详情
export const NESTLE_SYSTEM_BACK_SERVER_SYSTEM_USER_DETAIL = '/nestle-system-back-server/system/user/detail';
// 用户管理 -- 停用用户
export const NESTLE_SYSTEM_BACK_SERVER_SYSTEM_USER_DISABLED = '/nestle-system-back-server/system/user/disabled';
// 用户管理 -- 启用用户
export const NESTLE_SYSTEM_BACK_SERVER_SYSTEM_USER_ENABLED = '/nestle-system-back-server/system/user/enabled';
// 用户管理 -- 分页查询用户
export const NESTLE_SYSTEM_BACK_SERVER_SYSTEM_USER_PAGE = '/nestle-system-back-server/system/user/page';
// 用户管理 -- 保护用户
export const NESTLE_SYSTEM_BACK_SERVER_SYSTEM_USER_SAVE = '/nestle-system-back-server/system/user/save';
// 用户管理 -- 修改用户
export const NESTLE_SYSTEM_BACK_SERVER_SYSTEM_USER_UPDATE = '/nestle-system-back-server/system/user/update';
// 用户管理 -- 删除用户
export const NESTLE_SYSTEM_BACK_SERVER_SYSTEM_USER_DELETE = '/nestle-system-back-server/system/user/delete';
// 用户管理 -- 重置用户密码
export const NESTLE_SYSTEM_BACK_SERVER_SYSTEM_USER_RESET_PASSWORD = '/nestle-system-back-server/system/user/reset/password';

// APP版本管理
// APP版本管理 -- 删除版本
export const NESTLE_SYSTEM_BACK_SERVER_SYSTEM_APP_VERSION_DELETE = '/nestle-system-back-server/system/app/version/delete';
// APP版本管理 -- 版本详情
export const NESTLE_SYSTEM_BACK_SERVER_SYSTEM_APP_VERSION_DETAIL = '/nestle-system-back-server/system/app/version/detail';
// APP版本管理 -- 版本分页
export const NESTLE_SYSTEM_BACK_SERVER_SYSTEM_APP_VERSION_PAGE = '/nestle-system-back-server/system/app/version/page';
// APP版本管理 -- 保存
export const NESTLE_SYSTEM_BACK_SERVER_SYSTEM_APP_VERSION_SAVE = '/nestle-system-back-server/system/app/version/save';
// APP版本管理 -- 修改
export const NESTLE_SYSTEM_BACK_SERVER_SYSTEM_APP_VERSION_UPDATE = '/nestle-system-back-server/system/app/version/update';

// 操作日志
// 操作日志 -- 日志详情
export const NESTLE_SYSTEM_BACK_SERVER_SYSTEM_LOG_DETAIL = '/nestle-system-back-server/system/log/detail';
// 操作日志 -- 分页日志
export const NESTLE_SYSTEM_BACK_SERVER_SYSTEM_LOG_PAGE = '/nestle-system-back-server/system/log/page';
// 操作日志 -- 保存日志
export const NESTLE_SYSTEM_BACK_SERVER_SYSTEM_LOG_SAVE = '/nestle-system-back-server/system/log/save';
// 操作日志 -- 日志列表
export const NESTLE_SYSTEM_BACK_SERVER_SYSTEM_LOG_LIST = '/nestle-system-back-server/system/log/list';

// 系统配置
// 系统配置 -- 删除系统配置
export const NESTLE_SYSTEM_BACK_SERVER_SYSTEM_CONFIG_DELETE = '/nestle-system-back-server/system/config/delete';
// 系统配置 -- 系统配置详情
export const NESTLE_SYSTEM_BACK_SERVER_SYSTEM_CONFIG_DETAIL = '/nestle-system-back-server/system/config/detail';
// 系统配置 -- 系统配置分页
export const NESTLE_SYSTEM_BACK_SERVER_SYSTEM_CONFIG_PAGE = '/nestle-system-back-server/system/config/list';
// 系统配置 -- 保存系统配置
export const NESTLE_SYSTEM_BACK_SERVER_SYSTEM_CONFIG_SAVE = '/nestle-system-back-server/system/config/save';
// 系统配置 -- 修改系统配置
export const NESTLE_SYSTEM_BACK_SERVER_SYSTEM_CONFIG_UPDATE = '/nestle-system-back-server/system/config/update';
// 系统配置 -- 系统配置分组树形列表
export const NESTLE_SYSTEM_BACK_SERVER_SYSTEM_CONFIG_GROUP_LIST_TREE = '/nestle-system-back-server/system/config/group/list/tree';
// 系统配置 -- 系统配置分组保存
export const NESTLE_SYSTEM_BACK_SERVER_SYSTEM_CONFIG_GROUP_SAVE = '/nestle-system-back-server/system/config/group/save';
// 系统配置 -- 系统配置分组删除
export const NESTLE_SYSTEM_BACK_SERVER_SYSTEM_CONFIG_GROUP_DELETE = '/nestle-system-back-server/system/config/group/delete';
// 系统配置 -- 系统配置分组修改
export const NESTLE_SYSTEM_BACK_SERVER_SYSTEM_CONFIG_GROUP_UPDATE = '/nestle-system-back-server/system/config/group/update';

// 组织机构
// 组织机构 -- 组织机构列表
export const NESTLE_SYSTEM_BACK_SERVER_BASE_DATA_ORG_LIST = '/nestle-system-back-server/base/data/org/list';

// 数据字典
// 数据字典 -- 主数据列表
export const NESTLE_SYSTEM_BACK_SERVER_BASE_DATA_DICT_LIST = '/nestle-system-back-server/base/data/dict/list';
// 数据字典 -- 列表
export const NESTLE_SYSTEM_BACK_SERVER_SYSTEM_DICT_LIST = '/nestle-system-back-server/system/dict/list';
// 数据字典 -- 保存
export const NESTLE_SYSTEM_BACK_SERVER_SYSTEM_DICT_SAVE = '/nestle-system-back-server/system/dict/save';
// 数据字典 -- 修改
export const NESTLE_SYSTEM_BACK_SERVER_SYSTEM_DICT_UPDATE = '/nestle-system-back-server/system/dict/update';
// 数据字典 -- 详情
export const NESTLE_SYSTEM_BACK_SERVER_SYSTEM_DICT_DETAIL = '/nestle-system-back-server/system/dict/detail';
// 数据字典 -- 树形列表(无参)
export const NESTLE_SYSTEM_BACK_SERVER_SYSTEM_DICT_LIST_TREE = '/nestle-system-back-server/system/dict/list/tree';
// 数据字典 -- 树形列表(有参)
export const NESTLE_SYSTEM_BACK_SERVER_SYSTEM_DICT_LIST_TREE_CONDITION = '/nestle-system-back-server/system/dict/list/tree/condition';
// 数据字典 -- 数据字典列表（通过编码获取下级列表）
export const NESTLE_SYSTEM_BACK_SERVER_SYSTEM_DICT_LIST_BY_PARENTCODE = '/nestle-system-back-server/system/dict/list/by/parentCode';

// 渠道管理
// 渠道管理 -- 渠道详情
export const NESTLE_SYSTEM_BACK_SERVER_SYSTEM_SALE_CHANNEL_DETAIL = '/nestle-system-back-server/system/sale/channel/detail';
// 渠道管理 -- 渠道停用
export const NESTLE_SYSTEM_BACK_SERVER_SYSTEM_SALE_CHANNEL_DISABLED = '/nestle-system-back-server/system/sale/channel/disabled';
// 渠道管理 -- 渠道启用
export const NESTLE_SYSTEM_BACK_SERVER_SYSTEM_SALE_CHANNEL_ENABLED = '/nestle-system-back-server/system/sale/channel/enabled';
// 渠道管理 -- 渠道分页
export const NESTLE_SYSTEM_BACK_SERVER_SYSTEM_SALE_CHANNEL_PAGE = '/nestle-system-back-server/system/sale/channel/page';
// 渠道管理 -- 渠道不分页(code)
export const NESTLE_SYSTEM_BACK_SERVER_SYSTEM_SALE_CHANNEL_LIST_BY_CODES = '/nestle-system-back-server/system/sale/channel/list/by/codes';
// 渠道管理 -- 渠道不分页
export const NESTLE_SYSTEM_BACK_SERVER_SYSTEM_SALE_CHANNEL_LIST = '/nestle-system-back-server/system/sale/channel/list';
// 渠道管理 -- 渠道保存
export const NESTLE_SYSTEM_BACK_SERVER_SYSTEM_SALE_CHANNEL_SAVE = '/nestle-system-back-server/system/sale/channel/save';
// 渠道管理 -- 渠道修改
export const NESTLE_SYSTEM_BACK_SERVER_SYSTEM_SALE_CHANNEL_UPDATE = '/nestle-system-back-server/system/sale/channel/update';

// 会员管理
// 客户管理
// 客户管理 -- 客户列表
export const NESTLE_MEMBER_BACK_SERVER_BACK_MEMBER_USER_PAGELIST = '/nestle-member-back-server/back/member/user/pageList';
// 客户管理 -- 客户访问记录
export const NESTLE_MEMBER_BACK_SERVER_BACK_MEMBER_USER_VISIT_PAGELIST = '/nestle-member-back-server/back/member/user/visit/pageList';

// 分销员管理
// 分销员管理 -- 会员列表
export const NESTLE_MEMBER_BACK_SERVER_BACK_MEMBER_SHOP_MEMBER_PAGELIST = '/nestle-member-back-server/back/member/shop/member/pageList';
// 分销员管理 -- 会员数量
export const NESTLE_MEMBER_BACK_SERVER_BACK_MEMBER_SHOP_MEMBER_TYPE_COUNT = '/nestle-member-back-server/back/member/shop/member/type/count';
// 分销员管理 -- 会员详情
export const NESTLE_MEMBER_BACK_SERVER_BACK_MEMBER_SHOP_MEMBER_INFO_BYID = '/nestle-member-back-server/back/member/shop/member/infoById';
// 分销员管理 -- 修改密码
export const NESTLE_MEMBER_BACK_SERVER_BACK_MEMBER_SHOP_MEMBER_UPDATE_PASSWORD = '/nestle-member-back-server/back/member/shop/member/update/password';
// 分销员管理 -- 修改会员状态
export const NESTLE_MEMBER_BACK_SERVER_BACK_MEMBER_SHOP_MEMBER_UPDATE_STATUS = '/nestle-member-back-server/back/member/shop/member/update/status';

// 商户管理
// 推广公司管理
// 推广公司管理 -- 推广公司列表
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_COMPANY_PAGELIST = '/nestle-merchant-back-server/back/merchant/company/pageList';
// 同步主数据
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_COMPANY_UPDATACOMPANYBYMAINDATA = '/nestle-merchant-back-server/back/merchant/company/updateCompanyByMainData';
// 推广公司管理 -- 推广公司列表(不分页)
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_COMPANY_LIST = '/nestle-merchant-back-server/back/merchant/company/list';
// 推广公司管理 -- 推广公司列表(带权限不分页)
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SALESMAN_COMPANY_LIST = '/nestle-merchant-back-server/back/merchant/salesman/company/list';
// 推广公司管理 -- 添加推广公司
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_COMPANY_ADD = '/nestle-merchant-back-server/back/merchant/company/add';
// 推广公司管理 -- 修改推广公司
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_COMPANY_UPDATE = '/nestle-merchant-back-server/back/merchant/company/update';
// 推广公司管理 -- 推广公司详情
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_COMPANY_INFO = '/nestle-merchant-back-server/back/merchant/company/info';
// 推广公司管理 -- 删除推广公司
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_COMPANY_DELETE = '/nestle-merchant-back-server/back/merchant/company/delete';
// 推广公司管理 -- 修改推广公司状态
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_COMPANY_STATUS_UPDATE = '/nestle-merchant-back-server/back/merchant/company/status/update';
// 推广公司管理 -- 获取组织机构
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_COMPANY_ORGANIZATION_LIST =
  '/nestle-merchant-back-server/back/merchant/company/organization/list';

// 业务员管理
// 业务员管理 -- 业务员列表
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SALEMZN_PAGELIST = '/nestle-merchant-back-server/back/merchant/salesman/pageList';
// 业务员管理 -- 业务员列表(不分页)
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SALEMZN_LIST = '/nestle-merchant-back-server/back/merchant/salesman/list';
// 业务员管理 -- 未交接门店(不分页)
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SALEMZN_SHOP_LIST = '/nestle-merchant-back-server/back/merchant/salesman/shop/list';
// 业务员管理 -- 交接门店(不分页)
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SALEMZN_TRANSFER_SHOP_LIST =
  '/nestle-merchant-back-server/back/merchant/salesman/transfer/shop/list';
// 业务员管理 -- 交接门店
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SALEMZN_TRANSFER_SHOP = '/nestle-merchant-back-server/back/merchant/salesman/transfer/shop';
// 业务员管理 -- 离职
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SALEMZN_DIMISSION = '/nestle-merchant-back-server/back/merchant/salesman/dimission';
// 业务员管理 -- 业务员新增
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SALEMZN_ADD = '/nestle-merchant-back-server/back/merchant/salesman/add';
// 业务员管理 -- 业务员修改
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SALEMZN_UPDATE = '/nestle-merchant-back-server/back/merchant/salesman/update';
// 业务员管理 -- 业务员详情
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SALEMZN_INFO = '/nestle-merchant-back-server/back/merchant/salesman/info';

// 门店管理
// 门店管理 -- 门店列表(分页)
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_PAGELIST = '/nestle-merchant-back-server/back/merchant/shop/pageList';
// 门店管理 -- 门店列表(无分页)
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_LIST = '/nestle-merchant-back-server/back/merchant/shop/list';
// 门店管理 -- 修改门店状态
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_STATUS_UPDATE = '/nestle-merchant-back-server/back/merchant/shop/status/update';
// 门店管理 -- 门店审核
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_VERIFY = '/nestle-merchant-back-server/back/merchant/shop/verify';
// 门店管理 -- 门店详情
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_DETAIL = '/nestle-merchant-back-server/back/merchant/shop/info';
// 门店管理 -- 门店添加
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_ADD = '/nestle-merchant-back-server/back/merchant/shop/add';
// 门店管理 -- 门店编辑
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_UPDATE = '/nestle-merchant-back-server/back/merchant/shop/update';
// 门店管理 -- 客商信息
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_CUSTOMER_LIST = '/nestle-merchant-back-server/back/merchant/shop/customer/list';
// 门店管理 -- 分销管理
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_MEMBER_LIST = '/nestle-merchant-back-server/back/merchant/member/list';
// 门店管理 -- 附加信息详情
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_APPEND_INFO = '/nestle-merchant-back-server/back/merchant/shop/append/info';
// 门店管理 -- 修改附加信息
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_APPEND_INFO_UPDATE = '/nestle-merchant-back-server/back/merchant/shop/append/info/update';
// 门店管理 -- 店中店列表
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOPINSHOP_PAGELIST = '/nestle-merchant-back-server/back/merchant/shopInShop/pageList';
// 门店管理 -- 店中店新增
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOPINSHOP_ADD = '/nestle-merchant-back-server/back/merchant/shopInShop/add';
// 门店管理 -- 店中店状态更改
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOPINSHOP_VERIFY = '/nestle-merchant-back-server/back/merchant/shopInShop/verify';
// 门店管理 -- 店中店详情
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOPINSHOP_INFO = '/nestle-merchant-back-server/back/merchant/shopInShop/info';
// 门店管理 -- 店中店提交资料
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOPINSHOP_UPDATE_IMAGE = '/nestle-merchant-back-server/back/merchant/shopInShop/update/image';
// 门店管理 -- 门店批量导入excel模板下载
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_DOWNLOAD_MOULD_EXCEL =
  '/nestle-merchant-back-server/back/merchant/shop/download/mould/excel';
// 门店管理 -- 门店信息excel导入
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_UPLOAD_INFO_EXCEL = '/nestle-merchant-back-server/back/merchant/shop/upload/info/excel';
// 门店管理 -- 门店信息已审核通过excel导出
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_DOWNLOAD_PASSED_LODS =
  '/nestle-merchant-back-server/back/merchant/shop/download/passed/logs';
// 门店管理 -- 门店信息审核通过(支持批量)
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_IMPORT_AUDIT = '/nestle-merchant-back-server/back/merchant/shop/import/audit';

// 控货管理
// 控货管理 -- 控货列表
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_CONTROL_PAGELIST = '/nestle-merchant-back-server/back/merchant/control/pageList';
// 控货管理 -- 控货状态修改
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_CONTROL_STATUS_UPDATE = '/nestle-merchant-back-server/back/merchant/control/status/update';
// 控货管理 -- 添加控货
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_CONTROL_ADD = '/nestle-merchant-back-server/back/merchant/control/add';
// 控货管理 -- 编辑控货
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_CONTROL_UPDATE = '/nestle-merchant-back-server/back/merchant/control/update';
// 控货管理 -- 控货详情
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_CONTROL_INFO = '/nestle-merchant-back-server/back/merchant/control/info';

// 控货管理
// 控货申请表
// 控货申请表 -- 列表
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_GOODS_APPLY_PAGELIST =
  '/nestle-merchant-back-server/back/merchant/shop/goods/apply/pageList';
// 控货申请表 -- 详情
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_GOODS_APPLY_INFO = '/nestle-merchant-back-server/back/merchant/shop/goods/apply/info';
// 控货申请表 -- 审核
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_GOODS_APPLY_VERIFY = '/nestle-merchant-back-server/back/merchant/shop/goods/apply/verify';

// 客商管理
// 客商管理 -- 客商列表
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_CUSTOMER_PAGELIST = '/nestle-merchant-back-server/back/merchant/customer/pageList';
// 客商管理 -- 客商列表(不分页)
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_CUSTOMER_LIST = '/nestle-merchant-back-server/back/merchant/customer/list';
// 客商管理 -- 添加客商
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_CUSTOMER_ADD = '/nestle-merchant-back-server/back/merchant/customer/add';
// 客商管理 -- 修改客商
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_CUSTOMER_UPDATE = '/nestle-merchant-back-server/back/merchant/customer/update';
// 客商管理 -- 客商详情
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_CUSTOMER_INFO = '/nestle-merchant-back-server/back/merchant/customer/info';
// 客商管理 -- 客商审核
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_CUSTOMER_VERIFY = '/nestle-merchant-back-server/back/merchant/customer/verify';
// 客商管理 -- 修改客商状态
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_CUSTOMER_STATUS_UPDATE = '/nestle-merchant-back-server/back/merchant/customer/status/update';

// 门店等级管理
// 门店等级管理 -- 列表
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_GRADE_PAGELIST = '/nestle-merchant-back-server/back/merchant/shop/grade/pageList';
// 门店等级管理 -- 新增
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_GRADE_ADD = '/nestle-merchant-back-server/back/merchant/shop/grade/add';
// 门店等级管理 -- 编辑
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_GRADE_UPDATE = '/nestle-merchant-back-server/back/merchant/shop/grade/update';
// 门店等级管理 -- 详情
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_GRADE_INFO = '/nestle-merchant-back-server/back/merchant/shop/grade/info';
// 门店等级管理 -- 启停用状态切换
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_GRADE_STATUS_UPDATE =
  '/nestle-merchant-back-server/back/merchant/shop/grade/status/update';
// 门店等级管理 -- 晋升规则添加
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_GRADE_RULE_ADD = '/nestle-merchant-back-server/back/merchant/shop/grade/rule/add';
// 门店等级管理 -- 晋升规则编辑
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_GRADE_RULE_UPDATE = '/nestle-merchant-back-server/back/merchant/shop/grade/rule/update';
// 门店等级管理 -- 晋升规则详情
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_GRADE_RULE_INFO_BY_GRADE_ID =
  '/nestle-merchant-back-server/back/merchant/shop/grade/rule/info_by_grade_id';
// 根据code s列表查询门店列表
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_LISTBYCODES = '/nestle-merchant-back-server/back/merchant/shop/listByCodes';

// 消息管理
// 应用通知
// 消息管理 --应用通知列表
export const NESTLE_MESSAGE_BACK_SERVER_MESSAGE_APPLY_NOTICE_PAGE = '/nestle-message-back-server/message/apply/notice/page';
// 消息管理 --应用通知启用
export const NESTLE_MESSAGE_BACK_SERVER_MESSAGE_APPLY_NOTICE_ENABLED = '/nestle-message-back-server/message/apply/notice/enabled';
// 消息管理 --应用通知禁用
export const NESTLE_MESSAGE_BACK_SERVER_MESSAGE_APPLY_NOTICE_DISABLED = '/nestle-message-back-server/message/apply/notice/disabled';
// 消息管理 --应用通知详情
export const NESTLE_MESSAGE_BACK_SERVER_MESSAGE_APPLY_NOTICE_DETAIL = '/nestle-message-back-server/message/apply/notice/detail';
// 消息管理 --应用通知作废
export const NESTLE_MESSAGE_BACK_SERVER_MESSAGE_APPLY_NOTICE_CANCEL = '/nestle-message-back-server/message/apply/notice/cancel';
// 消息管理 --应用通知保存
export const NESTLE_MESSAGE_BACK_SERVER_MESSAGE_APPLY_NOTICE_SAVE = '/nestle-message-back-server/message/apply/notice/save';
// 消息管理 --应用通知推送
export const NESTLE_MESSAGE_BACK_SERVER_MESSAGE_APPLY_NOTICE_SEND = '/nestle-message-back-server/message/apply/notice/send';
// 消息管理 --应用通知修改
export const NESTLE_MESSAGE_BACK_SERVER_MESSAGE_APPLY_NOTICE_UPDATE = '/nestle-message-back-server/message/apply/notice/update';

// 文章管理
// 素材管理
// 素材管理 -- 素材列表
export const NESTLE_ARTICLE_BACK_SERVER_BACK_MATERIAL_PAGELIST = '/nestle-article-back-server/back/material/material/pageList';
// 素材管理 -- 素材列表
export const NESTLE_ARTICLE_BACK_SERVER_BACK_MATERIAL_STATUS_UPDATE = '/nestle-article-back-server/back/material/material/status/update';
// 素材管理 -- 素材详情
export const NESTLE_ARTICLE_BACK_SERVER_BACK_MATERIAL_INFO = '/nestle-article-back-server/back/material/material/info';
// 素材管理 -- 素材添加
export const NESTLE_ARTICLE_BACK_SERVER_BACK_MATERIAL_ADD = '/nestle-article-back-server/back/material/material/add';
// 素材管理 -- 素材修改
export const NESTLE_ARTICLE_BACK_SERVER_BACK_MATERIAL_UPDATE = '/nestle-article-back-server/back/material/material/update';
// 文章、内容管理
// 文章、内容管理 -- 列表
export const NESTLE_ARTICLE_BACK_SERVER_BACK_ARTICLE_MANAGEMENT_PAGELIST = '/nestle-article-back-server/back/article/management/pageList';
// 文章、内容管理 -- 添加
export const NESTLE_ARTICLE_BACK_SERVER_BACK_ARTICLE_MANAGEMENT_ADD = '/nestle-article-back-server/back/article/management/add';
// 文章、内容管理 -- 修改
export const NESTLE_ARTICLE_BACK_SERVER_BACK_ARTICLE_MANAGEMENT_UPDATE = '/nestle-article-back-server/back/article/management/update';
// 文章、内容管理 -- 详情
export const NESTLE_ARTICLE_BACK_SERVER_BACK_ARTICLE_MANAGEMENT_INFO = '/nestle-article-back-server/back/article/management/info';
// 文章、内容管理 -- 内容分类
export const NESTLE_ARTICLE_BACK_SERVER_BACK_ARTICLE_CATEGORY_CONTENT = '/nestle-article-back-server/back/article/category/content';
// 文章、内容管理 -- 文章分类
export const NESTLE_ARTICLE_BACK_SERVER_BACK_ARTICLE_CATEGORY_ARTICLE = '/nestle-article-back-server/back/article/category/article';
// 文章、内容管理 -- 启/停用
export const NESTLE_ARTICLE_BACK_SERVER_BACK_ARTICLE_MANAGEMENT_STATUS_UPDATE = '/nestle-article-back-server/back/article/management/status/update';

// 商品管理
// 商品列表(不分页)
export const NESTLE_GOODS_BACK_SERVER_GOODS_SALE_LIST = '/nestle-goods-back-server/goods/sale/list';
// 商品列表(分页)
export const NESTLE_GOODS_BACK_SERVER_GOODS_SALE_PAGE = '/nestle-goods-back-server/goods/sale/page';
// 商品销售信息列表-商品货号列表查询
export const NESTLE_GOODS_BACK_SERVER_GOODS_SALE_LIST_BY_GOODSCODESALE = '/nestle-goods-back-server/goods/sale/list/by/goodsCodeSale';
// 商品列表 -- 启用
export const NESTLE_GOODS_BACK_SERVER_GOODS_SALE_ENABLED = '/nestle-goods-back-server/goods/sale/enabled';
// 商品列表 -- 禁用
export const NESTLE_GOODS_BACK_SERVER_GOODS_SALE_DISABLED = '/nestle-goods-back-server/goods/sale/disabled';
// 商品列表 -- 设为（小程序）推荐
export const NESTLE_GOODS_BACK_SERVER_GOODS_SALE_SET_RECOMMEND = '/nestle-goods-back-server/goods/sale/set/recommend';
// 商品列表 -- 批量上架
export const NESTLE_GOODS_BACK_SERVER_GOODS_SALE_BATCH_ON_SHELF = '/nestle-goods-back-server/goods/sale/batch/on/shelf';
// 商品列表 -- 批量下架
export const NESTLE_GOODS_BACK_SERVER_GOODS_SALE_BATCH_OFF_SHELF = '/nestle-goods-back-server/goods/sale/batch/off/shelf';
// 商品列表 -- 商品销售价格信息
export const NESTLE_GOODS_BACK_SERVER_GOODS_SALE_LIST_PRICE = '/nestle-goods-back-server/goods/sale/list/price';
// 商品列表 -- 商品销售价格信息(分配了销售渠道的)
export const NESTLE_GOODS_BACK_SERVER_GOODS_SALE_LIST_PRICE_ON_SHELF = '/nestle-goods-back-server/goods/sale/list/price/on_shelf';
// 商品列表 -- 商品基础价格信息
export const NESTLE_GOODS_BACK_SERVER_GOODS_SALE_LIST_PRICE_BASIC = '/nestle-goods-back-server/goods/sale/list/price/basic';
// 商品列表 -- 商品销售销售信息
export const NESTLE_GOODS_BACK_SERVER_GOODS_SALE_LIST_SALE = '/nestle-goods-back-server/goods/sale/list/sale';
// 商品列表 -- 商品销售信息详情
export const NESTLE_GOODS_BACK_SERVER_GOODS_SALE_DETAIL = '/nestle-goods-back-server/goods/sale/detail';
// 商品列表 -- 批量设置标签
export const NESTLE_GOODS_BACK_SERVER_GOODS_SALE_SET_TAG_BATCH = '/nestle-goods-back-server/goods/sale/set/tag/batch';
// 商品列表 -- 商品销售信息保存
export const NESTLE_GOODS_BACK_SERVER_GOODS_SALE_SAVE = '/nestle-goods-back-server/goods/sale/save';
// 商品列表 -- 商品销售信息保存（供应模块使用）
export const NESTLE_GOODS_BACK_SERVER_GOODS_SALE_SAVE_SUPPLY = '/nestle-goods-back-server/goods/sale/save/supply';
// 商品列表 -- 商品销售信息修改
export const NESTLE_GOODS_BACK_SERVER_GOODS_SALE_UPDATE = '/nestle-goods-back-server/goods/sale/update';
// 商品列表 -- 商品销售(物料编码)
export const NESTLE_GOODS_BACK_SERVER_GOODS_SALE_LIST_BY_GOODS_CODE = '/nestle-goods-back-server/goods/sale/list/by/goods_code';
// 物料扩展信息管理
// 物料扩展信息管理 -- 分页列表
export const NESTLE_GOODS_BACK_SERVER_GOODS_MATERIAL_EXTEND_PAGE = '/nestle-goods-back-server/goods/material/extend/page';
// 物料扩展信息管理 -- 启用
export const NESTLE_GOODS_BACK_SERVER_GOODS_MATERIAL_EXTEND_ENABLED = '/nestle-goods-back-server/goods/material/extend/enabled';
// 物料扩展信息管理 -- 禁用
export const NESTLE_GOODS_BACK_SERVER_GOODS_MATERIAL_EXTEND_DISABLED = '/nestle-goods-back-server/goods/material/extend/disabled';
// 物料扩展信息管理 -- 基本信息详情
export const NESTLE_GOODS_BACK_SERVER_GOODS_MATERIAL_EXTEND_BASE_DATA_DETAIL = '/nestle-goods-back-server/goods/material/extend/base/data/detail';
// 物料扩展信息管理 -- 扩展信息详情
export const NESTLE_GOODS_BACK_SERVER_GOODS_MATERIAL_EXTEND_DETAIL = '/nestle-goods-back-server/goods/material/extend/detail';
// 物料扩展信息管理 -- 扩展信息详情(通过物料编码获取)
export const NESTLE_GOODS_BACK_SERVER_GOODS_MATERIAL_EXTEND_DETAIL_GOODSCODE = '/nestle-goods-back-server/goods/material/extend/detail/goodsCode';
// 物料扩展信息管理 -- 保存
export const NESTLE_GOODS_BACK_SERVER_GOODS_MATERIAL_EXTEND_SAVE = '/nestle-goods-back-server/goods/material/extend/save';
// 物料扩展信息管理 -- 修改
export const NESTLE_GOODS_BACK_SERVER_GOODS_MATERIAL_EXTEND_UPDATE = '/nestle-goods-back-server/goods/material/extend/update';
// 物料扩展信息管理 -- 同步
export const NESTLE_GOODS_BACK_SERVER_GOODS_MATERIAL_EXTEND_SYNC = '/nestle-goods-back-server/goods/material/extend/sync';
// 物料扩展信息管理 -- 物料信息是否存在
export const NESTLE_GOODS_BACK_SERVER_GOODS_MATERIAL_EXTEND_IS_EXIST = '/nestle-goods-back-server/goods/material/extend/is/exist';
// 物料扩展信息管理 -- 物料信息是否存在（主数据）
export const NESTLE_GOODS_BACK_SERVER_GOODS_MATERIAL_EXTEND_IS_EXIST_BY_BASE_DATA =
  '/nestle-goods-back-server/goods/material/extend/is/exist/by/base/data';
// 商品评价
// 商品评价 -- 评价列表
export const NESTLE_GOODS_BACK_SERVER_GOODS_COMMENT_PAGE = '/nestle-goods-back-server/goods/comment/page';
// 商品评价 -- 评价详情
export const NESTLE_GOODS_BACK_SERVER_GOODS_COMMENT_DETAIL = '/nestle-goods-back-server/goods/comment/detail';
// 商品评价 -- 评价审批
export const NESTLE_GOODS_BACK_SERVER_GOODS_COMMENT_AUDIT = '/nestle-goods-back-server/goods/comment/audit';
// 商品评价 -- 评价驳回
export const NESTLE_GOODS_BACK_SERVER_GOODS_COMMENT_REJECT = '/nestle-goods-back-server/goods/comment/reject';
// 品牌管理
// 品牌管理 -- 品牌列表(不分页)
export const NESTLE_SYSTEM_BACK_SERVER_BASE_DATA_BRAND_LIST = '/nestle-system-back-server/base/data/brand/list';
// 品牌管理 -- 品牌列表(分页)
export const NESTLE_GOODS_BACK_SERVER_GOODS_BRAND_EXTEND_PAGE = '/nestle-goods-back-server/goods/brand/extend/page';
// 品牌管理 -- 品牌详情
export const NESTLE_GOODS_BACK_SERVER_GOODS_BRAND_EXTEND_DETAIL = '/nestle-goods-back-server/goods/brand/extend/detail';
// 品牌管理 -- 修改品牌
export const NESTLE_GOODS_BACK_SERVER_GOODS_BRAND_EXTEND_UPDATE = '/nestle-goods-back-server/goods/brand/extend/update';
// 分类管理
// 分类管理 -- 商品分类列表(树形)
export const NESTLE_GOODS_BACK_SERVER_GOODS_TYPE_LIST_TREE = '/nestle-goods-back-server/goods/type/list/tree';
// 分类管理 -- 商品分类列表
export const NESTLE_GOODS_BACK_SERVER_GOODS_TYPE_LIST = '/nestle-goods-back-server/goods/type/list';
// 分类管理 -- 分类启用
export const NESTLE_GOODS_BACK_SERVER_GOODS_TYPE_ENABLED = '/nestle-goods-back-server/goods/type/enabled';
// 分类管理 -- 分类停用
export const NESTLE_GOODS_BACK_SERVER_GOODS_TYPE_DISABLED = '/nestle-goods-back-server/goods/type/disabled';
// 分类管理 -- 分类保存
export const NESTLE_GOODS_BACK_SERVER_GOODS_TYPE_SAVE = '/nestle-goods-back-server/goods/type/save';
// 分类管理 -- 分类修改
export const NESTLE_GOODS_BACK_SERVER_GOODS_TYPE_UPDATE = '/nestle-goods-back-server/goods/type/update';
// 分类管理 -- 分类详情
export const NESTLE_GOODS_BACK_SERVER_GOODS_TYPE_DETAIL = '/nestle-goods-back-server/goods/type/detail';
// 商品属性管理
// 商品属性管理 -- 属性列表(分页)
export const NESTLE_GOODS_BACK_SERVER_GOODS_ATTRIBUTE_PAGE = '/nestle-goods-back-server/goods/attribute/page';
// 商品属性管理 -- 属性列表(不分页)
export const NESTLE_GOODS_BACK_SERVER_GOODS_ATTRIBUTE_LIST = '/nestle-goods-back-server/goods/attribute/list';
// 商品属性管理 -- 属性列表(分类ID)
export const NESTLE_GOODS_BACK_SERVER_GOODS_ATTRIBUTE_LIST_BY_GOODSTYPEIDS = '/nestle-goods-back-server/goods/attribute/list/by/goodsTypeIds';
// 商品属性管理 -- 属性启用
export const NESTLE_GOODS_BACK_SERVER_GOODS_ATTRIBUTE_ENABLED = '/nestle-goods-back-server/goods/attribute/enabled';
// 商品属性管理 -- 属性停用
export const NESTLE_GOODS_BACK_SERVER_GOODS_ATTRIBUTE_DISABLED = '/nestle-goods-back-server/goods/attribute/disabled';
// 商品属性管理 -- 属性保存
export const NESTLE_GOODS_BACK_SERVER_GOODS_ATTRIBUTE_SAVE = '/nestle-goods-back-server/goods/attribute/save';
// 商品属性管理 -- 属性修改
export const NESTLE_GOODS_BACK_SERVER_GOODS_ATTRIBUTE_UPDATE = '/nestle-goods-back-server/goods/attribute/update';
// 商品属性管理 -- 属性详情
export const NESTLE_GOODS_BACK_SERVER_GOODS_ATTRIBUTE_DETAIL = '/nestle-goods-back-server/goods/attribute/detail';
// 商品价格管理
// 商品价格管理 -- 价格记录列表
export const NESTLE_GOODS_BACK_SERVER_GOODS_PRICE_RECORD_PAGE = '/nestle-goods-back-server/goods/price/record/page';
// 商品价格管理 -- 商品价格记录日志
export const NESTLE_GOODS_BACK_SERVER_GOODS_PRICE_RECORD_LOG = '/nestle-goods-back-server/goods/price/record/log';
// 商品价格管理 -- 商品价格记录导入
export const NESTLE_GOODS_BACK_SERVER_GOODS_PRICE_RECORD_IMPORT = '/nestle-goods-back-server/goods/price/record/import';
// 商品价格管理 -- 商品价格记录详情
export const NESTLE_GOODS_BACK_SERVER_GOODS_PRICE_RECORD_DETAIL = '/nestle-goods-back-server/goods/price/record/detail';
// 商品价格管理 -- 商品价格记录作废
export const NESTLE_GOODS_BACK_SERVER_GOODS_PRICE_RECORD_CANCEL = '/nestle-goods-back-server/goods/price/record/cancel';
// 商品价格管理 -- 商品价格记录审核
export const NESTLE_GOODS_BACK_SERVER_GOODS_PRICE_RECORD_AUDIT = '/nestle-goods-back-server/goods/price/record/audit';
// 商品价格管理 -- 商品价格记录详情审核
export const NESTLE_GOODS_BACK_SERVER_GOODS_PRICE_RECORD_AUDIT_DETAIL = '/nestle-goods-back-server/goods/price/record/audit/detail';
// 品牌归属国
// 品牌归属国 -- 列表
export const NESTLE_GOODS_BACK_SERVER_GOODS_BRAND_COUNTRY_LIST = '/nestle-goods-back-server/goods/brand/country/list';
// 品牌归属国 -- 新增/修改
export const NESTLE_GOODS_BACK_SERVER_GOODS_BRAND_COUNTRY_SAVE_OR_UPDATE = '/nestle-goods-back-server/goods/brand/country/save/or/update';

// 营销管理
// 广告位配置
// 广告位配置 -- 广告位类型列表
export const NESTLE_MARKETING_BACK_SERVER_ADVERT_POSITION_TYPE_LIST = '/nestle-marketing-back-server/advert/position/type/list';
// 广告位配置 -- 广告位类型保存
export const NESTLE_MARKETING_BACK_SERVER_ADVERT_POSITION_TYPE_SAVE = '/nestle-marketing-back-server/advert/position/type/save';
// 广告位配置 -- 广告位类型修改
export const NESTLE_MARKETING_BACK_SERVER_ADVERT_POSITION_TYPE_UPDATE = '/nestle-marketing-back-server/advert/position/type/update';
// 广告位配置 -- 广告位列表(不分页)
export const NESTLE_MARKETING_BACK_SERVER_ADVERT_POSITION_LIST = '/nestle-marketing-back-server/advert/position/list';
// 广告位配置 -- 广告位列表(分页)
export const NESTLE_MARKETING_BACK_SERVER_ADVERT_POSITION_PAGE = '/nestle-marketing-back-server/advert/position/page';
// 广告位配置 -- 广告位启用
export const NESTLE_MARKETING_BACK_SERVER_ADVERT_POSITION_ENABLED = '/nestle-marketing-back-server/advert/position/enabled';
// 广告位配置 -- 广告位禁用
export const NESTLE_MARKETING_BACK_SERVER_ADVERT_POSITION_DISABLED = '/nestle-marketing-back-server/advert/position/disabled';
// 广告位配置 -- 广告位详情
export const NESTLE_MARKETING_BACK_SERVER_ADVERT_POSITION_DETAIL = '/nestle-marketing-back-server/advert/position/detail';
// 广告位配置 -- 广告位保存
export const NESTLE_MARKETING_BACK_SERVER_ADVERT_POSITION_SAVE = '/nestle-marketing-back-server/advert/position/save';
// 广告位配置 -- 广告位修改
export const NESTLE_MARKETING_BACK_SERVER_ADVERT_POSITION_UPDATE = '/nestle-marketing-back-server/advert/position/update';
// 广告位配置 -- 广告列表
export const NESTLE_MARKETING_BACK_SERVER_ADVERT_LIST = '/nestle-marketing-back-server/advert/list';
// 广告位配置 -- 广告启用
export const NESTLE_MARKETING_BACK_SERVER_ADVERT_ENABLED = '/nestle-marketing-back-server/advert/enabled';
// 广告位配置 -- 广告禁用
export const NESTLE_MARKETING_BACK_SERVER_ADVERT_DISABLED = '/nestle-marketing-back-server/advert/disabled';
// 广告位配置 -- 广告详情
export const NESTLE_MARKETING_BACK_SERVER_ADVERT_DETAIL = '/nestle-marketing-back-server/advert/detail';
// 广告位配置 -- 广告保存
export const NESTLE_MARKETING_BACK_SERVER_ADVERT_SAVE = '/nestle-marketing-back-server/advert/save';
// 广告位配置 -- 广告修改
export const NESTLE_MARKETING_BACK_SERVER_ADVERT_UPDATE = '/nestle-marketing-back-server/advert/update';
// 广告位配置 -- 广告删除
export const NESTLE_MARKETING_BACK_SERVER_ADVERT_DELETE = '/nestle-marketing-back-server/advert/delete';
// 优惠券
// 优惠券 -- 优惠券列列表
export const NESTLE_MARKETING_BACK_SERVER_BONUS_PAGE = '/nestle-marketing-back-server/bonus/page';
// 优惠券 -- 优惠券审核
export const NESTLE_MARKETING_BACK_SERVER_BONUS_AUDIT = '/nestle-marketing-back-server/bonus/audit';
// 优惠券 -- 优惠券驳回
export const NESTLE_MARKETING_BACK_SERVER_BONUS_CANCEL = '/nestle-marketing-back-server/bonus/cancel';
// 优惠券 -- 优惠券详情
export const NESTLE_MARKETING_BACK_SERVER_BONUS_DETAIL = '/nestle-marketing-back-server/bonus/detail';
// 优惠券 -- 优惠券发放(B端)
export const NESTLE_MARKETING_BACK_SERVER_BONUS_GIVE = '/nestle-marketing-back-server/bonus/give';
// 优惠券 -- 优惠券发放(C端)
export const NESTLE_MARKETING_BACK_SERVER_BONUS_GIVE_TO_MEMBER = '/nestle-marketing-back-server/bonus/give/to/member';
// 优惠券 -- 优惠券发放统计
export const NESTLE_MARKETING_BACK_SERVER_BONUS_GIVE_COUNT = '/nestle-marketing-back-server/bonus/give/count';
// 优惠券 -- 优惠券已发放情况
export const NESTLE_MARKETING_BACK_SERVER_BONUS_GIVE_DETAIL = '/nestle-marketing-back-server/bonus/give/detail';
// 优惠券 -- 优惠券已发放情况(C端)
export const NESTLE_MARKETING_BACK_SERVER_BONUS_GIVE_DETAIL_BY_CLIENT = '/nestle-marketing-back-server/bonus/give/detail/by/c_client';
// 优惠券 -- 优惠券发放详情分页列表
export const NESTLE_MARKETING_BACK_SERVER_BONUS_GIVE_PAGE = '/nestle-marketing-back-server/bonus/give/page';
// 优惠券 -- 优惠券保存
export const NESTLE_MARKETING_BACK_SERVER_BONUS_SAVE = '/nestle-marketing-back-server/bonus/save';
// 优惠券 -- 优惠券修改
export const NESTLE_MARKETING_BACK_SERVER_BONUS_UPDATE = '/nestle-marketing-back-server/bonus/update';
// 优惠券 -- 优惠券启用
export const NESTLE_MARKETING_BACK_SERVER_BONUS_ENABLED = '/nestle-marketing-back-server/bonus/enabled';
// 优惠券 -- 优惠券停用
export const NESTLE_MARKETING_BACK_SERVER_BONUS_DISABELD = '/nestle-marketing-back-server/bonus/disabled';
// 优惠券 -- 导出优惠券发放详情
export const NESTLE_MARKETING_BACK_SERVER_BONUS_GIVE_EXPORT = '/nestle-marketing-back-server/bonus/give/export';
// 优惠券 -- 我方批次号列表
export const NESTLE_MARKETING_BACK_SERVER_BONUS_SALE_BATCH_NO_LIST = '/nestle-marketing-back-server/bonus/sale/batch/no/list';
// 折扣折价
// 折扣折价 -- 活动列表
export const NESTLE_MARKETING_BACK_SERVER_DISCOUNT_ACTIVITY_PAGE = '/nestle-marketing-back-server/discount/activity/page';
// 折扣折价 -- 活动审核
export const NESTLE_MARKETING_BACK_SERVER_DISCOUNT_ACTIVITY_AUDIT = '/nestle-marketing-back-server/discount/activity/audit';
// 折扣折价 -- 活动驳回
export const NESTLE_MARKETING_BACK_SERVER_DISCOUNT_ACTIVITY_REJECT = '/nestle-marketing-back-server/discount/activity/reject';
// 折扣折价 -- 活动详情
export const NESTLE_MARKETING_BACK_SERVER_DISCOUNT_ACTIVITY_DETAIL = '/nestle-marketing-back-server/discount/activity/detail';
// 折扣折价 -- 活动保存
export const NESTLE_MARKETING_BACK_SERVER_DISCOUNT_ACTIVITY_SAVE = '/nestle-marketing-back-server/discount/activity/save';
// 折扣折价 -- 活动修改
export const NESTLE_MARKETING_BACK_SERVER_DISCOUNT_ACTIVITY_UPDATE = '/nestle-marketing-back-server/discount/activity/update';
// 折扣折价 -- 启用活动
export const NESTLE_MARKETING_BACK_SERVER_DISCOUNT_ACTIVITY_ENABLED = '/nestle-marketing-back-server/discount/activity/enabled';
// 折扣折价 -- 停用活动
export const NESTLE_MARKETING_BACK_SERVER_DISCOUNT_ACTIVITY_DISABLED = '/nestle-marketing-back-server/discount/activity/disabled';
// 门店陈列
// 门店陈列 -- 活动列表
export const NESTLE_MARKETING_BACK_SERVER_DISPLAY_ACTIVITY_PAGE_LIST = '/nestle-marketing-back-server/display_activity/page_list';
// 门店陈列 -- 活动状态切换
export const NESTLE_MARKETING_BACK_SERVER_DISPLAY_ACTIVITY_STATUS_TOGGLE = '/nestle-marketing-back-server/display_activity/status_toggle';
// 门店陈列 -- 陈列活动创建
export const NESTLE_MARKETING_BACK_SERVER_DISPLAY_ACTIVITY_CREATE = '/nestle-marketing-back-server/display_activity/create';
// 门店陈列 -- 陈列活动编辑
export const NESTLE_MARKETING_BACK_SERVER_DISPLAY_ACTIVITY_UPDATE = '/nestle-marketing-back-server/display_activity/update';
// 门店陈列 -- 陈列活动详情
export const NESTLE_MARKETING_BACK_SERVER_DISPLAY_ACTIVITY_DETAIL = '/nestle-marketing-back-server/display_activity/detail';
// 门店陈列 -- 申请分页列表
export const NESTLE_MARKETING_BACK_SERVER_DISPLAY_ACTIVITY_APPLY_PAGE_LIST = '/nestle-marketing-back-server/display_activity/apply_page_list';
// 门店陈列 -- 陈列活动申请统计信息
export const NESTLE_MARKETING_BACK_SERVER_DISPLAY_ACTIVITY_APPLY_STATISTICS = '/nestle-marketing-back-server/display_activity/apply_statistics';
// 门店陈列 -- 申请详情
export const NESTLE_MARKETING_BACK_SERVER_DISPLAY_ACTIVITY_APPLY_DETAIL = '/nestle-marketing-back-server/display_activity/apply_detail';
// 门店陈列 -- 申请审核
export const NESTLE_MARKETING_BACK_SERVER_DISPLAY_ACTIVITY_APPLY_AUDIT = '/nestle-marketing-back-server/display_activity/apply_audit';
// 门店陈列 -- 申请导出
export const NESTLE_MARKETING_BACK_SERVER_DISPLAY_ACTIVITY_APPLY_EXPORT = '/nestle-marketing-back-server/display_activity/apply_export';
// 优惠活动
// 优惠活动 -- 活动列表
export const NESTLE_MARKETING_BACK_SERVER_PROMOTIONAL_ACTIVITY_PAGE = '/nestle-marketing-back-server/promotional_activity/page';
// 优惠活动 -- 活动详情
export const NESTLE_MARKETING_BACK_SERVER_PROMOTIONAL_ACTIVITY_DETAIL = '/nestle-marketing-back-server/promotional_activity/detail';
// 优惠活动 -- 活动编辑
export const NESTLE_MARKETING_BACK_SERVER_PROMOTIONAL_ACTIVITY_EDIT = '/nestle-marketing-back-server/promotional_activity/edit';
// 优惠活动 -- 活动创建
export const NESTLE_MARKETING_BACK_SERVER_PROMOTIONAL_ACTIVITY_CREATE = '/nestle-marketing-back-server/promotional_activity/create';
// 优惠活动 -- 模板下载
export const NESTLE_MARKETING_BACK_SERVER_PROMOTIONAL_ACTIVITY_IMPORTSHOPLIST_TEMPLATE = '/nestle-marketing-back-server/promotional_activity/importShopList/template';
// 优惠活动 -- 导入门店
export const NESTLE_MARKETING_BACK_SERVER_PROMOTIONAL_ACTIVITY_IMPORTSHOPLIST = '/nestle-marketing-back-server/promotional_activity/importShopList';
// 优惠活动 -- 作废
export const NESTLE_MARKETING_BACK_SERVER_PROMOTIONAL_ACTIVITY_ACTIVITYCANCEL = '/nestle-marketing-back-server/promotional_activity/activityCancel';
// 优惠活动 -- 强制结束
export const NESTLE_MARKETING_BACK_SERVER_PROMOTIONAL_ACTIVITY_ACTIVITYFORCECANCEL = '/nestle-marketing-back-server/promotional_activity/activityForceCancel';
// 交易管理
// 黑名单管理
// 黑名单管理 -- 黑名单列表
export const NESTLE_TRADE_BACK_SERVER_BLACKLIST_PAGE = '/nestle-trade-back-server/blacklist/page';
// 黑名单管理 -- 删除黑名单
export const NESTLE_TRADE_BACK_SERVER_BLACKLIST_DELETE = '/nestle-trade-back-server/blacklist/delete';
// 黑名单管理 -- 黑名单详情
export const NESTLE_TRADE_BACK_SERVER_BLACKLIST_DETAIL = '/nestle-trade-back-server/blacklist/detail';
// 黑名单管理 -- 新增黑名单
export const NESTLE_TRADE_BACK_SERVER_BLACKLIST_SAVE = '/nestle-trade-back-server/blacklist/save';
// 黑名单管理 -- 更新黑名单
export const NESTLE_TRADE_BACK_SERVER_BLACKLIST_UPDATE = '/nestle-trade-back-server/blacklist/update';

// 下单开关
// 下单开关 -- 下单开关列表
export const NESTLE_TRADE_BACK_SERVER_ORDER_BAN_RULE_PAGE = '/nestle-trade-back-server/order-ban-rule/page';
// 下单开关 -- 删除下单开关
export const NESTLE_TRADE_BACK_SERVER_ORDER_BAN_RULE_DELETE = '/nestle-trade-back-server/order-ban-rule/delete';
// 下单开关 -- 下单开关详情
export const NESTLE_TRADE_BACK_SERVER_ORDER_BAN_RULE_DETAIL = '/nestle-trade-back-server/order-ban-rule/detail';
// 下单开关 -- 新增下单开关
export const NESTLE_TRADE_BACK_SERVER_ORDER_BAN_RULE_SAVE = '/nestle-trade-back-server/order-ban-rule/save';
// 下单开关 -- 修改下单开关
export const NESTLE_TRADE_BACK_SERVER_ORDER_BAN_RULE_UPDATE = '/nestle-trade-back-server/order-ban-rule/update';
// 下单开关 -- 下单开关状态更改
export const NESTLE_TRADE_BACK_SERVER_ORDER_BAN_RULE_TOGGLE_DISABLED = '/nestle-trade-back-server/order-ban-rule/toggle-disabled';
// 下单开关 -- 获取所有省级行政单位
export const NESTLE_TRADE_BACK_SERVER_BASE_DATA_AREA_PROVINCE = '/nestle-trade-back-server/base-data/area/province';
// 下单开关 -- 获取所有库位分页列表
export const NESTLE_SYSTEM_BACK_SERVER_BASE_DATA_WARE_LIST = '/nestle-system-back-server/base/data/ware/list';

// 仓库设置
// 仓库设置 -- 仓库列表
export const NESTLE_TRADE_BACK_SERVER_WAREHOUSE_BUY_RULE_PAGE = '/nestle-trade-back-server/warehouse-buy-rule/page';
// 仓库设置 -- 仓库状态切换
export const NESTLE_TRADE_BACK_SERVER_WAREHOUSE_BUY_RULE_TOGGLE_DISABLED = '/nestle-trade-back-server/warehouse-buy-rule/toggle-disabled';
// 仓库设置 -- 删除仓库
export const NESTLE_TRADE_BACK_SERVER_WAREHOUSE_BUY_RULE_DELETE = '/nestle-trade-back-server/warehouse-buy-rule/delete';
// 仓库设置 -- 仓库详情
export const NESTLE_TRADE_BACK_SERVER_WAREHOUSE_BUY_RULE_DETAIL = '/nestle-trade-back-server/warehouse-buy-rule/detail';
// 仓库设置 -- 新增仓库
export const NESTLE_TRADE_BACK_SERVER_WAREHOUSE_BUY_RULE_CREATE = '/nestle-trade-back-server/warehouse-buy-rule/create';
// 仓库设置 -- 修改仓库
export const NESTLE_TRADE_BACK_SERVER_WAREHOUSE_BUY_RULE_UPDATE = '/nestle-trade-back-server/warehouse-buy-rule/update';
// 仓库设置 -- 分类限制设置
// 仓库设置 -- 分类限制设置 -- 新增
export const NESTLE_TRADE_BACK_SERVER_WBR_CATEGORY_CREATE = '/nestle-trade-back-server/wbr-category/create';
// 仓库设置 -- 分类限制设置 -- 修改
export const NESTLE_TRADE_BACK_SERVER_WBR_CATEGORY_UPDATE = '/nestle-trade-back-server/wbr-category/update';
// 仓库设置 -- 分类限制设置 -- 删除
export const NESTLE_TRADE_BACK_SERVER_WBR_CATEGORY_DELETE = '/nestle-trade-back-server/wbr-category/delete';

// 下单规则设置
// 下单规则 -- 规则列表
export const NESTLE_TRADE_BACK_SERVER_ORDER_RULE_PAGE = '/nestle-trade-back-server/order-rule/page';
// 下单规则 -- 规则详情
export const NESTLE_TRADE_BACK_SERVER_ORDER_RULE_DETAIL = '/nestle-trade-back-server/order-rule/detail';
// 下单规则 -- 新增规则
export const NESTLE_TRADE_BACK_SERVER_ORDER_RULE_CREATE = '/nestle-trade-back-server/order-rule/create';
// 下单规则 -- 修改规则
export const NESTLE_TRADE_BACK_SERVER_ORDER_RULE_UPDATE = '/nestle-trade-back-server/order-rule/update';
// 下单规则 -- 规则启停用状态切换
export const NESTLE_TRADE_BACK_SERVER_ORDER_RULE_TOGGLE_DISABLED = '/nestle-trade-back-server/order-rule/toggle-disabled';
// 下单规则 -- 删除规则
export const NESTLE_TRADE_BACK_SERVER_ORDER_RULE_DELETE = '/nestle-trade-back-server/order-rule/delete';
// 下单规则 -- 规则相关可选值
export const NESTLE_TRADE_BACK_SERVER_ORDER_RULE_OPTION_MAP = '/nestle-trade-back-server/order-rule/option-map';

// 运费模板设置
// 运费模板设置 -- 模板列表
export const NESTLE_TRADE_BACK_SERVER_SHIPPING_TEMPLATE_PAGE = '/nestle-trade-back-server/shipping-template/page';
// 运费模板设置 -- 删除模板
export const NESTLE_TRADE_BACK_SERVER_SHIPPING_TEMPLATE_DELETE = '/nestle-trade-back-server/shipping-template/delete';
// 运费模板设置 -- 模板状态切换
export const NESTLE_TRADE_BACK_SERVER_SHIPPING_TEMPLATE_TOGGLE_DISABLED = '/nestle-trade-back-server/shipping-template/toggle-disabled';
// 运费模板设置 -- 新增模板
export const NESTLE_TRADE_BACK_SERVER_SHIPPING_TEMPLATE_SAVE = '/nestle-trade-back-server/shipping-template/save';
// 运费模板设置 -- 修改模板
export const NESTLE_TRADE_BACK_SERVER_SHIPPING_TEMPLATE_UPDATE = '/nestle-trade-back-server/shipping-template/update';
// 运费模板设置 -- 模板详情
export const NESTLE_TRADE_BACK_SERVER_SHIPPING_TEMPLATE_DETAIL = '/nestle-trade-back-server/shipping-template/detail';
// 运费模板设置 -- 物流公司列表
export const NESTLE_TRADE_BACK_SERVER_ST_PROVIDER_FEE_PROVIDER_LIST = '/nestle-trade-back-server/st-provider-fee/provider-list';
// 运费模板设置 -- 新增运费设置
export const NESTLE_TRADE_BACK_SERVER_ST_PROVIDER_FEE_CREATE = '/nestle-trade-back-server/st-provider-fee/create';
// 运费模板设置 -- 修改运费设置
export const NESTLE_TRADE_BACK_SERVER_ST_PROVIDER_FEE_UPDATE = '/nestle-trade-back-server/st-provider-fee/update';
// 运费模板设置 -- 删除运费设置
export const NESTLE_TRADE_BACK_SERVER_ST_PROVIDER_FEE_DELETE = '/nestle-trade-back-server/st-provider-fee/delete';

// 订单管理
// 订单管理 -- 订单列表
export const NESTLE_TRADE_BACK_SERVER_ORDERS_PAGE = '/nestle-trade-back-server/orders/page';
// 订单管理 -- 订单详情
export const NESTLE_TRADE_BACK_SERVER_ORDERS_DETAIL = '/nestle-trade-back-server/orders/detail';
// 订单管理 -- 取消订单
export const NESTLE_TRADE_BACK_SERVER_ORDERS_CANCEL = '/nestle-trade-back-server/orders/cancel';
// 订单管理 -- 确认支付订单
export const NESTLE_TRADE_BACK_SERVER_ORDERS_COMFIRM_PAY = '/nestle-trade-back-server/orders/confirm-pay';
// 订单管理 -- 支付凭证上传
export const NESTLE_TRADE_BACK_SERVER_ORDERS_PAY_VOUCHER_UPLOAD = '/nestle-trade-back-server/orders/pay-voucher-upload';

// 队列消息管理
// 队列消息管理 -- 队列消息列表
export const NESTLE_TRADE_BACK_SERVER_MQ_SEND_TASK_PAGES = '/nestle-trade-back-server/mq-send-task/pages';
// 队列消息管理 -- 队列消息详情
export const NESTLE_TRADE_BACK_SERVER_MQ_SEND_TASK_LOGS = '/nestle-trade-back-server/mq-send-task/logs';
// 队列消息管理 -- 队列消息重试
export const NESTLE_TRADE_BACK_SERVER_MQ_SEND_TASK_RETRY = '/nestle-trade-back-server/mq-send-task/retry';

// 所有省列表数据
export const NESTLE_TRADE_BACK_SERVER_BASE_DATA_AREA_PROVIDER = '/nestle-trade-back-server/base-data/area/province';
// 所有市/区列表
export const NESTLE_TRADE_BACK_SERVER_BASE_DATA_AREA_LIST = '/nestle-trade-back-server/base-data/area/list';

export const NESTLE_TRADE_BACK_SERVER_BASE_DATA_WARE_SEAT_PAGE = '/nestle-trade-back-server/base-data/ware-seat-page';

// 文件上传
export const NESTLE_FILE_UPLOAD_SERVER_UPLOAD_OSS = '/nestle-file-upload-server/upload/oss';
// 修改密码
export const NESTLE_SYSTEM_BACK_SERVER_SYSTEM_USER_UPDATE_PASSWORD = '/nestle-system-back-server/system/user/update/password';

// 下载导入价格模板
export const NESTLE_GOODS_BACK_SERVER_GOODS_PRICE_PRICE_MOULD_DOWNLOAD_BY_PRICETYPE =
  '/nestle-goods-back-server/goods/price/mould/download/by/priceType';

// 返利管理
// 返利规则设置
// 返利规则设置 -- 模板下载
export const NESTLE_FINANCE_BACK_SERVER_REBATE_RULE_TEMPLATE = '/nestle-finance-back-server/rebate_rule/template';
// 返利规则设置 -- 列表
export const NESTLE_FINANCE_BACK_SERVER_REBATE_RULE_LIST = '/nestle-finance-back-server/rebate_rule/list';
// 返利规则设置 -- 可选销售渠道列表
export const NESTLE_FINANCE_BACK_SERVER_REBATE_RULE_SALE_CHANNELS = '/nestle-finance-back-server/rebate_rule/sale_channels';
// 返利规则设置 -- 导入
export const NESTLE_FINANCE_BACK_SERVER_REBATE_RULE_IMPORT_RULE = '/nestle-finance-back-server/rebate_rule/import_rule';
// 返利规则设置 -- 日志
export const NESTLE_FINANCE_BACK_SERVER_REBATE_RULE_LOGS = '/nestle-finance-back-server/rebate_rule/logs';
// 返利规则设置 -- 作废
export const NESTLE_FINANCE_BACK_SERVER_REBATE_RULE_REBATE_RULE_DISCARD = '/nestle-finance-back-server/rebate_rule/rebate_rule_discard';
// 返利规则设置 -- 审核
export const NESTLE_FINANCE_BACK_SERVER_REBATE_RULE_REBATE_RULE_ACCEPT = '/nestle-finance-back-server/rebate_rule/rebate_rule_accept';
// 返利规则设置 -- 详情
export const NESTLE_FINANCE_BACK_SERVER_REBATE_RULE_DETAIL = '/nestle-finance-back-server/rebate_rule/detail';
// 返利规则设置 -- 详情（审核）
export const NESTLE_FINANCE_BACK_SERVER_REBATE_RULE_REBATE_RULE_ITEM_ACCEPT = '/nestle-finance-back-server/rebate_rule/rebate_rule_item_accept';
// 返利规则设置 -- 详情（作废）
export const NESTLE_FINANCE_BACK_SERVER_REBATE_RULE_REBATE_RULE_ITEM_DISCARD = '/nestle-finance-back-server/rebate_rule/rebate_rule_item_discard';
// 返利规则查询 -- 列表
export const NESTLE_FINANCE_BACK_SERVER_REBATE_RULE_QUERY = '/nestle-finance-back-server/rebate_rule/query';
// 返利规则查询 -- 启停用
export const NESTLE_FINANCE_BACK_SERVER_REBATE_RULE_REBATE_RULE_ITEM_DISABLED = '/nestle-finance-back-server/rebate_rule/rebate_rule_item_disable';

// 主播管理
// 主播管理 -- 分页列表
export const NESTLE_BROADCAST_SERVER_BROADCAST_MEMBER_PAGE = '/nestle-broadcast-server/broadcast/member/page';
// 主播管理 -- 不分页列表
export const NESTLE_BROADCAST_SERVER_BROADCAST_MEMBER_LIST = '/nestle-broadcast-server/broadcast/member/list';
// 主播管理 -- 保存
export const NESTLE_BROADCAST_SERVER_BROADCAST_MEMBER_SAVE = '/nestle-broadcast-server/broadcast/member/save';
// 主播管理 -- 删除
export const NESTLE_BROADCAST_SERVER_BROADCAST_MEMBER_DELETE = '/nestle-broadcast-server/broadcast/member/delete';
// 直播间管理
// 直播间管理 --分页列表
export const NESTLE_BROADCAST_SERVER_BROADCAST_ROOM_PAGE = '/nestle-broadcast-server/broadcast/room/page';
// 直播间管理 --删除
export const NESTLE_BROADCAST_SERVER_BROADCAST_ROOM_DELETE = '/nestle-broadcast-server/broadcast/room/delete';
// 直播间管理 --审核
export const NESTLE_BROADCAST_SERVER_BROADCAST_ROOM_AUDIT = '/nestle-broadcast-server/broadcast/room/audit';
// 直播间管理 --添加
export const NESTLE_BROADCAST_SERVER_BROADCAST_ROOM_SAVE = '/nestle-broadcast-server/broadcast/room/save';
// 直播间管理 --修改
export const NESTLE_BROADCAST_SERVER_BROADCAST_ROOM_UPDATE = '/nestle-broadcast-server/broadcast/room/update';
// 直播间管理 --启停用
export const NESTLE_BROADCAST_SERVER_BROADCAST_ROOM_ENABLE = '/nestle-broadcast-server/broadcast/room/enable';
// 直播间管理 --详情（用于编辑）
export const NESTLE_BROADCAST_SERVER_BROADCAST_ROOM_DETAIL_EDIT = '/nestle-broadcast-server/broadcast/room/detail/edit';
// 直播间管理 --详情
export const NESTLE_BROADCAST_SERVER_BROADCAST_ROOM_DETAIL = '/nestle-broadcast-server/broadcast/room/detail';
// 直播间商品 -- 商品列表
export const NESTLE_GOODS_BACK_SERVER_GOODS_SALE_BROADCAST_PAGE = '/nestle-goods-back-server/goods/sale/broadcast/page';
// 直播间商品 -- 添加商品
export const NESTLE_GOODS_BACK_SERVER_GOODS_SALE_BROADCAST_SAVE = '/nestle-goods-back-server/goods/sale/broadcast/save';
// 直播间商品 -- 修改商品
export const NESTLE_GOODS_BACK_SERVER_GOODS_SALE_BROADCAST_UPDATE = '/nestle-goods-back-server/goods/sale/broadcast/update';
// 直播间商品 -- 修改直播商品价格
export const NESTLE_GOODS_BACK_SERVER_GOODS_SALE_BROADCAST_UPDATE_PRICE = '/nestle-goods-back-server/goods/sale/broadcast/update/price';
// 直播间商品 -- 删除商品
export const NESTLE_GOODS_BACK_SERVER_GOODS_SALE_BROADCAST_DELETE = '/nestle-goods-back-server/goods/sale/broadcast/delete';
// 直播间商品 -- 提交微信审核
export const NESTLE_GOODS_BACK_SERVER_GOODS_SALE_BROADCAST_AUDIT = '/nestle-goods-back-server/goods/sale/broadcast/audit';
// 直播间商品 -- 商品详情
export const NESTLE_GOODS_BACK_SERVER_GOODS_SALE_BROADCAST_EDIT_DETAIL = '/nestle-goods-back-server/goods/sale/broadcast/edit/detail';
// 直播间商品 -- 导入商品基本信息
export const NESTLE_GOODS_BACK_SERVER_GOODS_SALE_BROADCAST_SAVE_DETAIL = '/nestle-goods-back-server/goods/sale/broadcast/save/detail';
// 直播间商品 -- 导出已报名门店
export const NESTLE_BROADCAST_SERVER_BROADCAST_ROOM_PARTICIPATE_EXPORT = '/nestle-broadcast-server/broadcast/room/participate/export';
// 直播间商品 -- 观看直播会员列表
export const NESTLE_BROADCAST_SERVER_BROADCAST_USER_PARTICIPATOR_PAGE_LIST = '/nestle-broadcast-server/broadcast_user_participator/page_list';
// 直播间商品 -- 观看直播会员列表导出
export const NESTLE_BROADCAST_SERVER_BROADCAST_USER_PARTICIPATOR_EXPORT = '/nestle-broadcast-server/broadcast_user_participator/export';
// 资金管理
// 资金管理 -- 余额变动申请导入-列表
export const NESTLE_FINANCE_BACK_SERVER_ARTIFICIAL_IMPORT_LIST = '/nestle-finance-back-server/artificial/import_list';
// 资金管理 -- 余额变动申请导入-下载导入模板
export const NESTLE_FINANCE_BACK_SERVER_ARTIFICIAL_TEMPLATE = '/nestle-finance-back-server/artificial/template';
// 资金管理 -- 余额变动申请导入-导入
export const NESTLE_FINANCE_BACK_SERVER_ARTIFICIAL_PRE_IMPORT = '/nestle-finance-back-server/artificial/pre_import';
// 资金管理 -- 余额变动申请导入-审核
export const NESTLE_FINANCE_BACK_SERVER_ARTIFICIAL_ACCEPT_IMPORT = '/nestle-finance-back-server/artificial/accept_import';
// 资金管理 -- 余额变动申请导入-审核(ID)
export const NESTLE_FINANCE_BACK_SERVER_ARTIFICIAL_ACCEPT = '/nestle-finance-back-server/artificial/accept';
// 资金管理 -- 余额变动申请导入-作废
export const NESTLE_FINANCE_BACK_SERVER_ARTIFICIAL_DISCARD_IMPORT = '/nestle-finance-back-server/artificial/discard_import';
// 资金管理 -- 余额变动申请导入-作废(ID)
export const NESTLE_FINANCE_BACK_SERVER_ARTIFICIAL_DISCARD = '/nestle-finance-back-server/artificial/discard';
// 资金管理 -- 余额变动申请导入-详情
export const NESTLE_FINANCE_BACK_SERVER_ARTIFICIAL_IMPORT_DETAIL = '/nestle-finance-back-server/artificial/import_detail';
// 资金管理 -- 余额变动申请导入(ID)
export const NESTLE_FINANCE_BACK_SERVER_ARTIFICIAL_EXECUTE_IMPORT_BY_ID = '/nestle-finance-back-server/artificial/execute_import_by_id';
// 资金管理 -- 余额变动申请导入状态列表
export const NESTLE_FINANCE_BACK_SERVER_ARTIFICIAL_IMPORT_LIST_OPTIONS = '/nestle-finance-back-server/artificial/import_list_options';
// 资金管理 -- 余额变动申请状态列表
export const NESTLE_FINANCE_BACK_SERVER_ARTIFICIAL_LIST_OPTIONS = '/nestle-finance-back-server/artificial/list_options';
// 资金管理 -- 余额变动申请列表
export const NESTLE_FINANCE_BACK_SERVER_ARTIFICIAL_LIST = '/nestle-finance-back-server/artificial/list';
// 资金管理 -- 余额变动申请详情
export const NESTLE_FINANCE_BACK_SERVER_ARTIFICIAL_DETAIL = '/nestle-finance-back-server/artificial/detail';
// 资金管理 -- 余额变动申请日志
export const NESTLE_FINANCE_BACK_SERVER_ARTIFICIAL_LOGS = '/nestle-finance-back-server/artificial/logs';
// 资金管理 -- 余额变动申请-申请
export const NESTLE_FINANCE_BACK_SERVER_ARTIFICIAL_APPLY = '/nestle-finance-back-server/artificial/apply';
// 资金管理 -- 收支明细-列表
export const NESTLE_FINANCE_BACK_SERVER_FLOW_LIST = '/nestle-finance-back-server/flow/list';
// 资金管理 -- 收支明细-列表筛选项
export const NESTLE_FINANCE_BACK_SERVER_FLOW_LIST_OPTIONS = '/nestle-finance-back-server/flow/list_options';

//提现管理
//账户审核记录列表
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_BANK_AUDIT_INDEX = '/nestle-merchant-back-server/back/merchant/shop-bank-audit/index';
//账户审核日志
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_BANK_AUDIT_LOGS = '/nestle-merchant-back-server/back/merchant/shop-bank-audit/logs';
//账户审核操作
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_BANK_AUDIT_OPERATOR = '/nestle-merchant-back-server/back/merchant/shop-bank-audit/operator';
//账户审核状态值
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_BANK_AUDIT_STATUS = '/nestle-merchant-back-server/back/merchant/shop-bank-audit/status';
//账户审核详情
export const NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_BANK_AUDIT_DETAIL = '/nestle-merchant-back-server/back/merchant/shop-bank-audit/detail';

// 商品管理 -- 配额管理 -- 分页列表
export const NESTLE_GOODS_BACK_SERVER_GOODS_QUOTA_PAGE = "/nestle-goods-back-server/goods/quota/page";
// 商品管理 -- 配额管理 -- 审核
export const NESTLE_GOODS_BACK_SERVER_GOODS_QUOTA_VERIFY = "/nestle-goods-back-server/goods/quota/verify";
// 商品管理 -- 配额管理 -- 作废
export const NESTLE_GOODS_BACK_SERVER_GOODS_QUOTA_CANCEL = "/nestle-goods-back-server/goods/quota/cancel";
// 商品管理 -- 配额管理 -- 新增
export const NESTLE_GOODS_BACK_SERVER_GOODS_QUOTA_ADD = "/nestle-goods-back-server/goods/quota/add";
// 商品管理 -- 配额管理 -- 编辑
export const NESTLE_GOODS_BACK_SERVER_GOODS_QUOTA_EDIT = "/nestle-goods-back-server/goods/quota/edit";
// 商品管理 -- 配额管理 -- 导入门店配额
export const NESTLE_GOODS_BACK_SERVER_GOODS_QUOTA_IMPORTSHOP = "/nestle-goods-back-server/goods/quota/importShop";
// 商品管理 -- 配额管理 -- 查看配额
export const NESTLE_GOODS_BACK_SERVER_GOODS_QUOTA_GETGOODSQUOTA = "/nestle-goods-back-server/goods/quota/getGoodsQuota";
// 商品管理 -- 配额管理 -- 查看配额明细
export const NESTLE_GOODS_BACK_SERVER_GOODS_QUOTA_GETGOODSQUOTADETAIL = "/nestle-goods-back-server/goods/quota/getGoodsQuotaDetail";
// 商品管理 -- 配额管理 -- 门店配额模板下载
export const NESTLE_SYSTEM_BACK_SERVER_SYSTEM_CONFIG_DETAIL_BY_IDENTIFY = "/nestle-system-back-server/system/config/detail/by/identify";
// 商品管理 -- 配额管理 -- 根据商品编码获取商品批次号
export const NESTLE_SUPPLY_BACK_SERVER_SALE_GET_BY_GOODS_CODE = '/nestle-supply-back-server/sale/get_by_goods_code';
// 商品管理 -- 配额管理 -- 导出
export const NESTLE_GOODS_BACK_SERVER_GOODS_QUOTA_EXPORT_QUOTA_DETAIL = "/nestle-goods-back-server/goods/quota/export_quota_detail";
